/**
 * MessagingWindowWarning — aviso prévio de que a janela de 24h da Meta
 * (WhatsApp Business / Instagram / Messenger) está perto de fechar.
 *
 * Fica ACIMA da sendbar, que continua liberada (o composer só bloqueia em
 * `window_closed` — ver `MessagingWindowBlock`). Distinção visual do bloco de
 * bloqueio: mais baixa (`py-2` vs `py-3.5`) e SEM dot pulsante — é aviso, não
 * bloqueio.
 *
 * `reopenWith`/`remainingLabel` vêm de `useMessagingWindow` (Task 12).
 */

interface MessagingWindowWarningProps {
  reopenWith: 'template' | 'customer_only';
  remainingLabel: string;
}

export function MessagingWindowWarning({ reopenWith, remainingLabel }: MessagingWindowWarningProps) {
  return (
    <div
      className="flex items-center justify-center gap-2 px-4 py-2 text-sm"
      style={{ backgroundColor: '#fffbeb', color: '#b45309' }}
      data-testid="chat-messaging-window-warning"
    >
      <span>
        A janela de 24 horas fecha em {remainingLabel}. Depois disso,{' '}
        {reopenWith === 'template' ? 'só com template.' : 'só quando o cliente responder.'}
      </span>
    </div>
  );
}
